<template>
  <div class="space-y-8">
    <div class="border border-gray-400 rounded overflow-hidden">
      <div v-if="loading" class="p-6 text-center">
        <Loader />
      </div>
      <table v-else class="table-auto w-full text-sm" style="border-style: hidden">
        <TableHeader
          :notification-channels="notificationChannels"
          :user-notification-settings="internalUserNotificationSettings"
          :disabled="updating"
        />
        <TableBody
          v-for="notificationSetting in notificationSettings"
          :key="notificationSetting.code"
          :notification-setting="notificationSetting"
          :user-notification-settings="internalUserNotificationSettings"
          :disabled="updating"
        >
          <td
            v-for="notificationChannel in notificationChannels"
            :key="`${notificationSetting.code}:${notificationChannel.code}`"
            class="px-4 py-3 border border-gray-400 text-center"
          >
            <portal-target :name="`${notificationSetting.code}:${notificationChannel.code}`" />
          </td>
        </TableBody>
      </table>
    </div>

    <div>
      <BaseButton primary :disabled="updating" @click="updateUserNotificationSettings">
        Update
      </BaseButton>
    </div>

    <portal
      v-for="setting in internalUserNotificationSettings"
      :key="`${setting.notificationSettingCode}:${setting.notificationChannelCode}`"
      :to="`${setting.notificationSettingCode}:${setting.notificationChannelCode}`"
    >
      <input type="checkbox" :disabled="updating" v-model="setting.isEnabled" />
    </portal>
  </div>
</template>

<script>
import TableHeader from './notificationSettings/TableHeader.vue';
import TableBody from './notificationSettings/TableBody.vue';

export default {
  name: 'NotificationSettingsForm',
  components: { TableHeader, TableBody },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      updating: false,
      internalUserNotificationSettings: [],
    };
  },
  computed: {
    notificationSettings() {
      return this.$store.getters['ui/notificationSettings/notificationSettings'];
    },
    notificationChannels() {
      return this.$store.getters['ui/notificationChannels/notificationChannels'];
    },
    userNotificationSettings() {
      return this.$store.getters['admin/userNotificationSettings/userNotificationSettings'];
    },
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      try {
        this.loading = true;

        await this.$store.dispatch({
          type: 'ui/notificationSettings/load',
        });

        await this.$store.dispatch({
          type: 'ui/notificationChannels/load',
        });

        await this.$store.dispatch({
          type: 'admin/userNotificationSettings/load',
          userId: this.userId,
        });

        this.setInternalUserNotificationSettings();
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    setInternalUserNotificationSettings() {
      this.internalUserNotificationSettings = JSON.parse(
        JSON.stringify(this.userNotificationSettings)
      );
    },
    async updateUserNotificationSettings() {
      try {
        this.updating = true;
        await this.$store.dispatch({
          type: 'admin/userNotificationSettings/update',
          userId: this.userId,
          formData: { data: this.internalUserNotificationSettings },
        });
      } catch (error) {
        //
      } finally {
        this.updating = false;
      }
    },
  },
};
</script>
